//
//
//
//
//
//
//
//
//

export default {
  props: {
    selected: {
      default: false
    },
    disabled: {
      default: null
    }
  }
}
